import { z } from "zod"

export const B2CSignUpSchema = z.object({
  gender: z.string().min(1, { message: "Gender is required!" }),
  firstname: z.string().min(1, { message: "First name is required!" }),
  lastname: z.string().min(1, { message: "Last name is required!" }),
  email: z.string().email({ message: "Email is required" }),
  password: z
    .string()
    .min(8, { message: "Be at least 8 characters long" })
    .regex(/[a-zA-Z]/, { message: "Contain at least one letter." })
    .regex(/[0-9]/, { message: "Contain at least one number." })
    .regex(/[^a-zA-Z0-9]/, {
      message: "Contain at least one special character.",
    })
    .trim(),
})

export type B2CSignUpForm = z.infer<typeof B2CSignUpSchema>

export const B2BSignUpSchema = z.object({
  gender: z.string().min(1, { message: "Gender is required!" }),
  firstname: z.string().min(1, { message: "First name is required!" }),
  lastname: z.string().min(1, { message: "Last name is required!" }),
  email: z.string().email({ message: "Email is required" }),
  password: z
    .string()
    .min(8, { message: "Be at least 8 characters long" })
    .regex(/[a-zA-Z]/, { message: "Contain at least one letter." })
    .regex(/[0-9]/, { message: "Contain at least one number." })
    .regex(/[^a-zA-Z0-9]/, {
      message: "Contain at least one special character.",
    })
    .trim(),
})

export type B2BSignUpForm = z.infer<typeof B2BSignUpSchema>
